import React from 'react';

const ToggleLeft = () => (
  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 1.7143L2.25 6 6 10.2857 5.25 12 0 6l5.25-6L6 1.7143z" fill="#fff" />
  </svg>
);

export default ToggleLeft;
